import React from "react";
import { useNavigate } from "react-router-dom";
import cn from 'classnames';
// import "./index.css";
//import moment from "moment";
//import { current_datetime } from "../../../controller/utils";
import { NAMES_CONSTANTS } from '../../constants';
import PropertyStatistics from './PropertyStatistics';
import {
      base_url
    , PopUpAlert
    , PopUpWarning
    , PopUpWarningThen
    , PopUpConfirmation
} from "../../controller/utils";

export default function PropertyInformation({
      productInfo
    , productDetails
    , categoryName
    , showAmenities
    , loginRegisterFunctions
    , handleAddToCart
}) {
    //console.debug('PropertyInformation(productInfo, productDetails, categoryName, showAmenities, loginRegisterFunctions)');
    console.debug('PropertyInformation()');

    const navigate = useNavigate();
    let userAccessToken = localStorage.getItem(NAMES_CONSTANTS.USER_ACCESS_TOKEN);
    //const datetime = new Date();
    let fileIndex = 0;

    //console.debug('PropertyInformation: productInfo = ', productInfo);
    //console.debug('PropertyInformation: productDetails = ', productDetails);
    //console.debug('PropertyInformation: categoryName = ', categoryName);
    //console.debug('PropertyInformation: userAccessToken = ', userAccessToken);

    const clickInvestNowWhenLoggedIn = () => {

        // Pop up: You are currently being processed for KYC.
        //PopUpAlert('Connection Successful', 'You are now connected', 'success')
        //PopUpAlert('Investor KYC and Accreditation Process', 'You are currently being processed for KYC.', 'warning')
        //PopUpWarning('Investor KYC and Accreditation Process', 'You are currently being processed for KYC. ', 'warning')
        //PopUpWarning('Investor KYC and Accreditation Process', 'You are currently being processed for KYC. ', 'warning')
        //PopUpWarning('Investor Accreditation Process', 'Your account is currently being processed for KYC. We will email you about this deal once your account is approved.', 'warning')
        //PopUpWarning('Investor Accreditation Process', 'This deal will be going live soon. We will send you an email notification confirming the go-live date. You will need to pass KYC/AML before you can invest.', 'warning')
        PopUpConfirmation('This deal will be going live soon. We will send you an email notification confirming the go-live date. You will need to pass KYC/AML before you can invest.', '', 'warning')

            .then(result => {
                console.debug('result = ', result);
                /*
                setLoginModal(false);
                getBalanceToken();
                if (referralCode) {
                    dispatch(referralCodeUpdate(null))
                }
                */
            });
    };

    return (

        <section
            //className = { "property-information" }
            className = {
                cn([
                    "property-information"
                    , productInfo?.status
                    , productDetails?.status
                ])
            }
            style = {{ paddingTop: "0px" }}
            >

            <div
                className = { 'max-width' }
                style = {{
                    backgroundColor: '#021736'
                }}
                >

                {/*
                <div className = { 'property-information' }>
                */}
                <div
                    className = 'property-information about-section'
                    style = {{
                        paddingTop: "0px"
                        , paddingTop: productDetails?.id == 1 ? '1px' : '0px'
                    }}
                    //style = {{ paddingBottom: '50px' }}
                    >
                
                    <div
                        className = 'about-section item-container'
                        //className = 'about-section'
                        style = {{
                            //paddingBottom: '50px'
                            //, marginBottom: '50px'
                            textAlign: 'center'
                            //, marginTop: '0px'
                            , marginTop: productDetails?.id == 1 ? '90px' : '0px' // Adjust for the LORE banner image in the header
                        }}
                        >

                        {
                            productDetails?.id == 1
                            && <div
                                className = 'about-section-circle-wrapper lore-logo'
                                //style = {{
                                //    textAlign: 'center'
                                //    , margin: 'auto'
                                //    , marginTop: '-65px'
                                //}}
                                >

                                <div className = 'about-section-circle lore-logo no-filter'>
                                    <img
                                        //src = '/images/icons/setting-map-location-black-icon.svg'
                                        //src = '/images/icons/company-info-icon.svg'
                                        //src = '/images/logos/LORE-ONLY_white.png'
                                        //src = '/images/properties/LORE/LORE-PLACE_head.png'
                                        src = '/images/properties/LORE/LORE-Lion-Head_426x494.png'
                                        />
                                </div>
                            </div>
                        }

                        {/*
                        <h2>{ productDetails?.name } <br />Property Information</h2>
                        <h2>Meet LORE LA</h2>
                        <h2>Meet { productDetails?.name }</h2>
                        */}

                        <div
                            //className = 'flex-box section-header'
                            className = 'section-header'
                            style = {{
                            //    , justifyContent: 'center'
                                display: 'table'
                                , margin: 'auto'
                            }}
                            >

                            {/*
                            */}
                            <div
                                className = 'cell'
                                //className = 'flex-item section-header-left'
                                style = {{
                                    verticalAlign: 'middle'
                                //    , width: '120px'
                                //    , textAlign: 'left'
                                    //, marginLeft: 'auto'
                                    //, marginRight: 'auto'
                                }}
                                >
                                <img
                                    className = 'realsplit-logo left'
                                    src = '/images/Sensei-Labs/RealSplit-New-Logo-Building-Only_512x512.png'
                                    style = {{
                                        maxHeight: '65px'
                                        //, verticalAlign: 'top'
                                        , verticalAlign: 'baseline'
                                        //, maxWidth: '50px'
                                        //, padding: '0px 20px'
                                        //, paddingRight: '10px'
                                        //, paddingLeft: '20px'
                                    }}
                                    />
                            </div>

                            <div
                                className = 'cell'>
                                    
                                    <h2
                                        //className = { styles.sectionTitle }
                                        style = {{
                                            margin: '0'
                                            //textAlign: 'left'
                                            //padding: '50px 20px 40px 20px'
                                            //, fontSize: 'unset'
                                            //, fontSize: '45px'
                                            //, whiteSpace: 'nowrap'
                                            //, verticalAlign: 'baseline'
                                            //, textAlign: 'left'
                                        }}
                                        >
                                        
                                        {
                                            productDetails?.title
                                            ? productDetails?.title
                                            : productDetails?.name
                                        }
                                    </h2>
                            </div>

                            <div
                                className = 'cell'
                                style = {{
                                    verticalAlign: 'middle'
                                }}
                                >

                                <img
                                    className = 'realsplit-logo right'
                                    src = '/images/Sensei-Labs/RealSplit-New-Logo-Building-Only_512x512.png'
                                    style = {{
                                        maxHeight: '65px'
                                        //, padding: '0px 20px'
                                        //, maxWidth: '50px'
                                        //, verticalAlign: 'baseline'
                                        , verticalAlign: 'middle'
                                        //, paddingLeft: '10px'
                                        //, paddingRight: '20px'
                                    }}
                                    />
                            </div>


                                    
                            {/*
                            </div>
                            */}

                        </div>

                        {/*
                        <div
                            className = 'flex-box section-header'
                            >
                            <div
                                className = 'flex-item section-header-left'
                                >
                                <img
                                    className = 'realsplit-logo'
                                    src = '/images/Sensei-Labs/RealSplit-New-Logo-Building-Only_512x512.png'
                                    />
                            </div>

                            <div
                                //className = 'cell'
                                className = 'flex-item'
                                >
                                <h2
                                    style = {{
                                        padding: '50px 0px 40px 0px'
                                        , margin: '0'
                                        //, fontSize: 'unset'
                                        , whiteSpace: 'nowrap'
                                    }}
                                    >
                                    {
                                        productDetails?.title
                                        ? productDetails?.title
                                        : productDetails?.name
                                    }
                                </h2>
                            </div>

                            <div
                                className = 'flex-item section-header-right'
                                >
                                <img
                                    className = 'realsplit-logo'
                                    src = '/images/Sensei-Labs/RealSplit-New-Logo-Building-Only_512x512.png'
                                    />
                            </div>
                        </div>
                        */}

                        {
                            productDetails?.sizzle
                            &&
                        <p>
                            <h3
                                style = {{
                                    textAlign: 'left'
                                    , padding: '0px'
                                    , margin: '0px'
                                    //, fontFamily: 'DM Sans'
                                }}>
                                { productDetails?.sizzle }
                            </h3>
                        </p>
                        }

                        {/*
                        <p>
                            { productDetails?.intro }
                        </p>
                        */}

                        <p
                            style = {{
                                textAlign: "center"
                                , margin: "0px"
                                //, padding: "0px"
                                //, padding: "20px 0px"
                                , padding: "0px"
                            }}>
                            {/*
                            <img src='/images/properties/property1/property1-map.jpg' />
                            */}
                            <img
                                src = {
                                    productDetails?.thumbnailUrl
                                    || productDetails?.mediaPreviewUrl
                                    //'http://localhost:3010/static/media/hillcrest_sensei_render.a663ff5c94a20d783bda.jpg'
                                }
                                style = {{
                                      width: '100%'
                                    //, maxWidth: '640px'
                                    //, objectFit: 'cover'
                                }}
                                />
                        </p>

                        <PropertyStatistics
                            productInfo = { productInfo }
                            productDetails = { productDetails }
                            //categoryName = { categoryName }
                            />

                        {/*
                        <p>
                            { productDetails?.shortDescription }
                        </p>
                        */}

                        <div
                            className = 'item-information'
                            dangerouslySetInnerHTML = {{ __html: productDetails?.shortDescription }}
                            />

                        {/*
                          Files:
                            id, name, type, url, previewUrl, size, position, isThumbnail, defaultThumbnailUrl, isShortVideo, isIpfs, cid, assetId, createdAt, updatedAt
                        <p>
                            
                            Files: { productDetails?.files?.length }
                            <br/>
                            {
                                productDetails?.files?.length
                                && productDetails.files.map((el, i) => {
                                  return (
                                    <div>
                                        { el.previewUrl }
                                    </div>
                                )})
                            }
                        </p>
                        */}

                        {
                            productDetails?.files?.length > 0
                            && 
                            <div
                                className = { 'item-images' }
                                key = { fileIndex++ }
                                style = {{
                                    textAlign: "center"
                                    , margin: "0px"
                                    , padding: "20px 0px"
                                }}
                                >

                                <div
                                    className = { 'item-images-container' }
                                    style = {{
                                        //  display: "flex"
                                        //, flexWrap: "wrap"
                                        //, gap: "10px"
                                    }}
                                    >

                                    {
                                        productDetails?.files?.length > 0
                                        && productDetails.files
                                            //.sort((a, b) => a.id - b.id)
                                            .sort((a, b) => a.position - b.position)
                                            .map((el, i) => {
                                          //i == 0 ? return null;
                                          //i == 0 && return null;
                                          //if (i == 0) return null;
                                          return (
                                            <div
                                                className = { 'item-image' }
                                                key = { i }
                                                //style = {{ flexBasis: "calc(50% - 10px)" }}
                                                style = {{
                                                    //flexBasis: "calc(50% - 10px)"
                                                    backgroundImage: 'url(' + el.previewUrl + ')'
                                                    //, objectFit: 'cover'
                                                    //, backgroundPosition: 'center center'
                                                    //, backgroundSize: 'cover'
                                                    //, width: '100%'
                                                    //, height: '100%'
                                                    //, maxHeight: '170px'
                                                    //, height: '250px'
                                                }}
                                                >
                                                {/*
                                                <img
                                                    src = { el.previewUrl }
                                                    //style = {{ width: '100%', height: '-webkit-fill-available' }}
                                                    />
                                                */}
                                            </div>
                                        )})
                                    }
                                </div>
                            </div>
                        }

                        {/*
                        <p>
                            { productDetails?.description }
                        </p>
                        */}
                        <div dangerouslySetInnerHTML = {{ __html: productDetails?.description }} />

                        {
                            productDetails?.strategy
                            && <>
                                <h4>Demographic Information</h4>
                                <p>
                                    { productDetails?.demographics }
                                </p>
                                <hr style = {{ backgroundColor: "#CED4DA", lineHeight: "1px", margin: "20px 0px 20px 0px" }} />
                            </>
                        }

                        {/*
                            productDetails?.status != 'past-deal'
                            && (
                                <p style = {{ textAlign: "center" }}>
                                    <button
                                        type = 'button'
                                        className = 'theme-success large'
                                        onClick = {() => handleAddToCart(productDetails) }
                                        >Invest Now</button>
                                </p>
                            )
                        */}

                        {
                            //productDetails?.status == 'Due Diligence'
                            productDetails?.status == 'due-diligence'
                            && <>

                                {
                                    !userAccessToken
                                    && <div
                                        style = {{
                                            textAlign: 'center'
                                            , margin: 'auto'
                                            //, marginBottom: '-90px'
                                            , paddingTop: '20px'
                                            , paddingBottom: '20px'
                                        }}
                                        >

                                        <div
                                            //className = 'about-section-circle no-filter'
                                            >

                                            <button
                                                /*
                                                style = {{
                                                    background: 'var(--color-theme-primary)'
                                                    , color: 'white'
                                                    , border: 'white 4px solid'
                                                    , borderRadius: '0'
                                                    , padding: '20px 50px'
                                                    , fontSize: '36px'
                                                    , fontFamily: '"Baskervville", serif'
                                                }}
                                                */
                                                className = 'theme-sensei theme-sensei-inverted'
                                                onClick = { (event) => {
                                                    if (!userAccessToken) {
                                                        //props.loginRegisterFunctions.clickRegister(event);
                                                        loginRegisterFunctions.clickRegister(event);
                                                        return;
                                                    } else {
                                                        //window.open('https://realsplit.deal.tribexa.com/deal/create-investment', '_blank').focus();
                                                        navigate('/search/all')
                                                    }
                                                }}
                                                >
                                                Sign Up
                                            </button>
                                        </div>
                                    </div>
                                }

                                <div
                                    className = 'text-content'
                                    style = {{
                                        fontSize: '.85em'
                                        , lineHeight: '22px'
                                        //, letterSpacing: '-1px'
                                        //, fontFamily: 'Roboto'
                                        //, fontFamily: 'Source+Sans+3'
                                        //, fontFamily: 'Source Sans 3'
                                        //, fontFamily: 'Poppins'
                                        //, fontFamily: 'Red+Hat+Display'
                                        , fontFamily: 'Red Hat Display'
                                        , fontWeight: '400'
                                        , textAlign: 'justify'
                                        , paddingBottom: '30px'
                                        , marginBottom: '30px'
                                    }}
                                    >
                                    <h4
                                        style = {{
                                            paddingBottom: '10px'
                                            , paddingTop: '10px'
                                        }}
                                        >Legal Disclaimer</h4>
                                    {/*
                                    <strong style={{ paddingBottom: '5px' }}>Legal Disclaimer</strong>
                                    <br/>The properties displayed on this website are provided strictly for informational purposes and are part of an internal due diligence review process. These listings do not constitute an offer to sell, a solicitation to purchase, or an official marketing of any property. We do not own, control, or represent any interest in the properties referenced herein. We are not acting as the broker, agent, or representative of record for any such property. All properties are exclusively offered by third-party entities, including but not limited to [XYZ Company], and any inquiries or negotiations regarding the properties should be directed to the offering parties. No representations, warranties, or guarantees, express or implied, are made regarding the completeness, accuracy, or reliability of the information provided.
                                    <br/>The properties listed on this website are presented solely for informational and preliminary due diligence purposes. These listings do not constitute an official offer to sell, lease, or represent any property. We do not own, represent, or act as a broker for any of the properties featured.
                                    */}
                                    The properties listed under due diligence on this website are presented solely for informational and preliminary assessment purposes. These due diligence listings do not constitute an official offer to sell, lease, or represent any property. We do not own, represent, or act as a broker for any of the due diligence properties featured, however community feedback is welcome.
                                </div>
                            </>
                        }

                        {
                            productDetails?.status != 'due-diligence'
                            && <div
                                style = {{
                                    textAlign: 'center'
                                    , margin: 'auto'
                                    //, marginBottom: '-90px'
                                    //, paddingTop: '50px'
                                    //, paddingBottom: '50px'
                                    , paddingTop: '20px'
                                    , paddingBottom: '30px'
                                }}
                                >
                                <div
                                    //className = 'about-section-circle no-filter'
                                    >
                                    <button
                                        /*
                                        style = {{
                                            background: 'var(--color-theme-primary)'
                                            , color: 'white'
                                            , border: 'white 4px solid'
                                            , borderRadius: '0'
                                            , padding: '20px 50px'
                                            , fontSize: '36px'
                                            , fontFamily: '"Baskervville", serif'
                                        }}
                                        */
                                        className = 'theme-sensei theme-sensei-inverted'
                                        onClick = { (event) => {
                                            if (!userAccessToken) {
                                                //props.loginRegisterFunctions.clickRegister(event);
                                                loginRegisterFunctions.clickRegister(event);
                                                return;
                                            } else {
                                                //window.open('https://realsplit.deal.tribexa.com/deal/create-investment', '_blank').focus();
                                                //navigate('/search/all')
                                                //props.handleAddToCart();
                                                //handleAddToCart();
                                                clickInvestNowWhenLoggedIn();
                                                // Pop up: You are currently being processed for KYC.
                                            }
                                        }}
                                        >
                                        Invest Now
                                    </button>
                                </div>
                            </div>
                        }

                    </div>

                    {
                        (
                            productDetails?.amenities
                            || productDetails?.strategy
                        )
                        && showAmenities
                        &&  <div className = 'about-section'>

                            <div
                                className = 'about-section-circle-wrapper'
                                //style = {{
                                //    textAlign: 'center'
                                //    , margin: 'auto'
                                //    , marginTop: '-65px'
                                //}}
                                >
                                <div className = 'about-section-circle'>
                                    <img
                                        src = '/images/icons/setting-map-location-black-icon.svg'
                                        //src = '/images/icons/service-provider-icon.svg'
                                        style = {{
                                              height: '100px'
                                            //, marginTop: '-100px'
                                            //, marginBottom: '-30px'
                                            //, height: 'auto'
                                            //, width: '100px'
                                            //, filter: 'brightness(0) saturate(100%) invert(22%) sepia(62%) saturate(3018%) hue-rotate(203deg) brightness(97%) contrast(99%)'
                                        }}
                                        />
                                </div>
                            </div>

                            {
                                productDetails?.amenities
                                //productDetails?.amenities && productDetails?.amenities.length > 0
                                &&
                                    <>
                                    <h2>Amenities</h2>
                                    <p
                                        //style = {{ paddingRight: '20px' }}
                                        dangerouslySetInnerHTML = {{ __html: productDetails?.amenities }}
                                        />
                                    {/*<hr style = {{ backgroundColor: "#CED4DA", lineHeight: "1px", margin: "0px 0px 0px 0px" }} />*/}

                                    {
                                        productDetails?.status != 'due-diligence'
                                        && <div
                                            style = {{
                                                textAlign: 'center'
                                                , margin: 'auto'
                                                //, marginBottom: '-90px'
                                                //, paddingTop: '50px'
                                                //, paddingBottom: '50px'
                                                , paddingTop: '20px'
                                                , paddingBottom: '30px'
                                            }}
                                            >
                                            <div
                                                //className = 'about-section-circle no-filter'
                                                >
                                                <button
                                                    /*
                                                    style = {{
                                                        background: 'var(--color-theme-primary)'
                                                        , color: 'white'
                                                        , border: 'white 4px solid'
                                                        , borderRadius: '0'
                                                        , padding: '20px 50px'
                                                        , fontSize: '36px'
                                                        , fontFamily: '"Baskervville", serif'
                                                    }}
                                                    */
                                                    className = 'theme-sensei theme-sensei-inverted'
                                                    onClick = { (event) => {
                                                        if (!userAccessToken) {
                                                            //props.loginRegisterFunctions.clickRegister(event);
                                                            loginRegisterFunctions.clickRegister(event);
                                                            return;
                                                        } else {
                                                            //window.open('https://realsplit.deal.tribexa.com/deal/create-investment', '_blank').focus();
                                                            //navigate('/search/all')
                                                            //props.handleAddToCart();
                                                            //handleAddToCart();
                                                            clickInvestNowWhenLoggedIn();
                                                            // Pop up: You are currently being processed for KYC.
                                                        }
                                                    }}
                                                    >
                                                    Invest Now
                                                </button>
                                            </div>
                                        </div>
                                    }
                                    </>
                            }

                            {
                                productDetails?.strategy
                                &&
                                    <>
                                    <h3>Strategy</h3>
                                    <div
                                        style = {{ paddingRight: '20px' }}
                                        dangerouslySetInnerHTML={{ __html: productDetails?.strategy }}
                                        />
                                    </>
                            }

                            {/*
                            <h3>Other Financials</h3>

                            <div
                                className = { "table financials-table" }
                                style = {{
                                    width: "100%"
                                }}
                                >
                                <div className = { "row" }>
                                    <div className = { "cell" }>
                                        Original Purchase Date:
                                    </div>
                                    <div className = { "cell" }>
                                        { 
                                            productDetails?.purchaseDate
                                            &&
                                                new Date(
                                                    Date.parse(productDetails.purchaseDate)
                                                )
                                                .toLocaleDateString(
                                                    "en-US"
                                                    //, { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' }
                                                    , { year: 'numeric', month: 'long', day: 'numeric' }
                                                )
                                        }
                                    </div>
                                </div>

                                <div className = { "row" }>
                                    <div className = { "cell" }>
                                        Original Purchase Price:
                                    </div>
                                    <div className = { "cell" }>
                                        { productDetails?.purchasePrice }
                                    </div>
                                </div>

                                {
                                    productDetails?.downPayment
                                    && <div className = { "row" }>
                                        <div className = { "cell" }>
                                            Initial Down Payment:
                                        </div>
                                        <div className = { "cell" }>
                                            { productDetails?.downPayment }
                                        </div>
                                    </div>
                                }

                                {
                                    productDetails?.loanAmount
                                    && <div className = { "row" }>
                                        <div className = { "cell" }>
                                            Original Loan Amount:
                                        </div>
                                        <div className = { "cell" }>
                                            { productDetails?.loanAmount }
                                        </div>
                                    </div>
                                }

                                {
                                    productDetails?.interestRate
                                    && <div className = { "row" }>
                                        <div className = { "cell" }>
                                            Interest Rate
                                        </div>
                                        <div className = { "cell" }>
                                            { productDetails?.interestRate }
                                        </div>
                                    </div>
                                }

                                {
                                    productDetails?.loanTerm
                                    && <div className = { "row" }>
                                        <div className = { "cell" }>
                                            Loan Term:
                                        </div>
                                        <div className = { "cell" }>
                                            { productDetails?.loanTerm }
                                        </div>
                                    </div>
                                }
                            </div>
                            */}
                        </div>
                    }

                    {
                        productDetails?.status != 'past-deal'
                        || false // temporary to remove this unused html
                        && (
                            <>

                            {/*<hr style = {{ backgroundColor: "#CED4DA", lineHeight: "1px", margin: "25px 0" }} />*/}

                            {/*
                            <p style = {{ textAlign: "center", margin: "0px", padding: "0px" }}>
                            */}
                            <div
                                style = {{
                                    textAlign: "center"
                                    , margin: "0px"
                                    , padding: "40px 0px"
                                }}>

                                {/*
                                <button
                                    type="button"
                                    className = { cn("theme-primary")}
                                    //className = { styles.dark }
                                    //onclick="followLink('/search.jsp')"
                                    //style={{ textShadow: "0px 1px 2px #1657F5", paddingTop: "20px", paddingBottom: "20px" }}
                                    style={{
                                          padding: "6px 12px"
                                        , backgroundColor: "rgba(0, 0, 255, 1)"
                                        //, background: "#0000FF"
                                        , borderRadius: "5px"
                                        , color: "#FFF"
                                        , fontFamily: "'Source Sans 3'"
                                        , fontWeight: "400"
                                        , fontSize: "20px"

                                    }}
                                    >Invest Now</button>
                                */}

                                {/*
                                <button
                                    type = 'button'
                                    className = 'theme-success large text-shadow'
                                    style = {{ 
                                        boxShadow: 'var(--color-gray-400) 0px 3px 8px 0px'
                                    }}
                                    //onClick = {() => props.handleAddToCart(productDetails) }
                                    onClick = {(event) => {
                                        if (
                                               !props.userDetails
                                            || !props.userDetails?.id
                                        ) {
                                            props.loginRegisterFunctions.clickRegister(event);
                                            return;
                                        } else {
                                            window.open('https://realsplit.deal.tribexa.com/deal/create-investment', '_blank').focus();
                                        }
                                    }}
                                    >Invest Now</button>
                                */}

                            </div>
                            </>
                        )
                    }

                </div>
            </div>
        </section>
    );
}
